(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["skinnybuddha-story"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.sb-story a[href]').forEach((link) => {
  const url = new URL(link.href, window.location.href);
  if ((url.protocol === 'https:' || url.protocol === 'http:') && url.origin !== window.location.origin) {
    link.target = '_blank';
    link.rel = [link.rel, 'noopener', link.closest('[data-sponsored="true"]') ? 'sponsored' : ''].filter(Boolean).join(' ');
    link.title = 'Opens in a new tab';
  }
});
  } catch(e) { console.error(e); }
})();

})();
